import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiHttpResponse, Workout } from '@kinomap-dev/ng-ui-lib';
import { map } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment.local';
import { Comment } from '@kinomap-dev/ng-ui-lib/lib/models/comment.model';
import { PostCommentResponse } from 'app/modules/dashboard/models/comments.model';

export type SortType = 'latest' | 'popular' | 'duration' | 'difficulty';
export type SortDirectionType = 'asc' | 'desc';
export type WorkoutModeType =
  | 'ftp'
  | 'res'
  | 'pma'
  | 'inc'
  | 'slope'
  | 'spd'
  | 'watts'
  | null;

@Injectable({
  providedIn: 'root',
})
export class WorkoutService {
  constructor(private http: HttpClient) { }

  getWorkout(id: number): Observable<Workout> {
    const url: string = environment.api.trainingLog.getWorkout.replace(
      '{workoutId}',
      '' + id
    );
    return this.http.get<ApiHttpResponse<Workout>>(url).pipe(
      map((response: ApiHttpResponse<Workout>) => {
        return response.data;
      })
    );
  }

  getWorkoutByUser(
    userId: number,
    sport,
    minDuration: number = 1,
    maxDuration: number = 99999999999,
    sortType: SortType = 'latest',
    sortDirection: SortDirectionType = 'desc',
    page: number = 1,
    limit: number = 15
  ): Observable<Workout[]> {
    const url: string = environment.api.workout.byUser.replace(
      '{userId}',
      userId.toString()
    );
    return this.http
      .get<ApiHttpResponse<Workout[]>>(url, {
        params: {
          sport,
          minDuration,
          maxDuration,
          sortType,
          sortDirection,
          page,
          limit,
        },
      })
      .pipe(
        map((response) => {
          return response.data;
        })
      );
  }

  report(
    workoutId: number,
    resaon: string,
    authorReportedId: number
  ): Observable<string> {
    const env: 'dev' | 'prod' = environment.production ? 'prod' : 'dev';
    const workoutUrl: string = `https://www.kinomap.${env === 'prod' ? 'com' : 'dev'}/browse/workout/${workoutId}`;
    const authorUrl: string = `https://www.kinomap.${env === 'prod' ? 'com' : 'dev'}/dashboard/profile/${authorReportedId}`;
    const url: string = environment.api.workout.report;
    const requestBody: {
      title: string;
      platform: 'website';
      version: 'dev' | 'prod';
      deviceId: string;
      deviceModel: string;
      userComment: string;
    } = {
      title: `Report Workout [${workoutId}]`,
      platform: 'website',
      version: env,
      deviceId: '--',
      deviceModel: window.navigator.userAgent.toString(),
      userComment: `${env === 'dev' ? '!!!! --- TEST EN DEV --- !!!!' : ''}
      workout reported id : ${workoutId}
      workout url : ${workoutUrl}
      reason of report : ${resaon}
      author of reported workout : ${authorUrl}`,
    };
    return this.http
      .post(url, requestBody)
      .pipe(map((response: any) => response.data.message));
  }

  addLike(workoutId: number): Observable<any> {
    const url: string = environment.api.workout.likes.replace(
      '{workoutId}',
      workoutId.toString()
    );
    return this.http
      .post<ApiHttpResponse<any>>(url, {})
      .pipe(map((response: ApiHttpResponse<any>) => response.data));
  }

  removeLike(workoutId: number): Observable<{
    likes_count: number;
    dislikes_count: number;
  }> {
    const url: string = environment.api.workout.likes.replace(
      '{workoutId}',
      workoutId.toString()
    );
    return this.http
      .delete<ApiHttpResponse<any>>(url, {})
      .pipe(map((response: ApiHttpResponse<any>) => response.data));
  }
}
